import { Skeleton } from '@dsg-tech/homefield-react';

// This is what the height of one of the nav items ends up being once font-size and line-height are
// factored in. Not sure if there's a better way to dynamically define this. Edit this value if you
// need to adjust the height of a nav item for CLS!
//
// Last Updated: 8/26/2025
const TRENDING_SEARCH_BADGE_HEIGHT = '32px';

const PlaceholderBadge = () => (
  <Skeleton height={TRENDING_SEARCH_BADGE_HEIGHT} width={100} borderRadius={50} />
);

const TrendingSearchesPending = () => {
  return (
    <div
      data-testid="TrendingSearchesPending"
      className="trending-searches-container hmf-display-flex hmf-justify-content-left hmf-justify-content-xlg-center">
      <section
        className="trending-searches hmf-display-flex hmf-align-items-center hmf-px-s hmf-pb-xs hmf-px-md-m"
        id="trendingSearchBar">
        <div className="chip-container hmf-flex-no-wrap hmf-display-flex hmf-lg-flex-wrap">
          <PlaceholderBadge />
          <PlaceholderBadge />
          <PlaceholderBadge />
          <PlaceholderBadge />
        </div>
      </section>
    </div>
  );
};

export default TrendingSearchesPending;
